// import React, { useEffect, useState } from "react";

// interface RepairDetailsProps {
//   repair: any;
//   onClose: () => void;
// }

// const RepairDetails: React.FC<RepairDetailsProps> = ({ repair, onClose }) => {
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     // Force light color scheme to avoid OKLCH
//     document.documentElement.style.colorScheme = "light";
//   }, []);

//   const formatDate = (date?: string) => {
//     if (!date) return "N/A";
//     try {
//       return new Date(date).toLocaleDateString();
//     } catch {
//       return "Invalid Date";
//     }
//   };

//   if (!repair) {
//     return (
//       <div className="bg-white p-5 rounded-lg shadow-lg text-center">
//         <p>No repair data available.</p>
//         <button
//           onClick={onClose}
//           className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md"
//         >
//           Close
//         </button>
//       </div>
//     );
//   }

//   return (
//     <div
//       id="repair-details-section"
//       className="lg:w-4xl xl:w-4xl w-xs lg:max-h-[700px] xl:max-h-[700px] max-h-[700px] overflow-y-auto overflow-x-hidden no-scrollbar rounded-xl bg-white py-5 px-10 flex flex-col"
//       style={{ color: "black" }}
//     >
//       {/* Logo */}
//       <img src="/images/logo.png" className="w-32 mb-4 self-center" alt="Logo" />

//       {/* Close button */}
//       <button
//         className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-2xl font-bold z-10"
//         onClick={onClose}
//       >
//         &times;
//       </button>

//       {/* Top 3-column layout */}
//       <div className="grid grid-cols-3 gap-6 items-start mt-6 mb-2">

//         {/* ✅ LEFT: Generated By */}
//         <div className="flex flex-col text-start text-sm px-2">
//           <img
//             src="/images/user-pic.png"
//             className="w-15 h-15 bg-gray-100 rounded-full my-2"
//             alt="user"
//           />

//           <span className="font-mono font-semibold text-lg">Generated By</span>

//           <span>
//             Employee Name:{" "}
//             <span className="font-semibold">
//               {repair.createdBy?.username || "N/A"}
//             </span>
//           </span>

//           <span>
//             Employee Id:{" "}
//             <span className="font-semibold text-blue-500 underline">
//               {repair.createdBy?.employeeId || "N/A"}
//             </span>
//           </span>

//         </div>

//         {/* ✅ CENTER: intentionally blank */}
//         <div></div>

//         {/* ✅ RIGHT: Order Header + ServerId Info */}
//         <div className="flex flex-col text-end text-sm px-2">

//           {/* Order Header (UNCHANGED) */}
//           <span className="text-xs font-semibold">Order Number</span>

//           <span className="text-blue-600 underline text-lg font-semibold font-mono">
//             #{repair.orderNumber || "N/A"}
//           </span>

//           <span className="text-xs font-semibold mt-2">
//             Receiving Date:{" "}
//             <span className="font-bold">
//               {formatDate(repair.receivingDate)}
//             </span>
//           </span>

//           <span className="text-xs font-semibold">
//             Expected Delivery Date:{" "}
//             <span className="font-bold">
//               {formatDate(repair.expectedDeliveryDate)}
//             </span>
//           </span>

//           {/* WARRANTY + REQUEST TYPE LABEL */}
//           {repair.warrantyType && (
//             <div className="mt-1 text-xs font-semibold flex justify-end items-center gap-2">

//               {/* WARRANTY LABEL */}
//               <span
//                 className="px-3 py-1 rounded-full bg-gray-200 text-black whitespace-nowrap"
//               >
//                 {repair.warrantyType === "CUW"
//                   ? "Complaint Under Warranty"
//                   : repair.warrantyType === "COW"
//                     ? "Complaint Out of Warranty"
//                     : ""}
//               </span>

//               {/* REQUEST TYPE LABEL */}
//               <span
//                 className={`px-3 py-1 rounded-full text-white text-xs whitespace-nowrap ${repair.requestType === "repair"
//                     ? "bg-blue-500"
//                     : repair.requestType === "replacement"
//                       ? "bg-green-500"
//                       : "bg-gray-500"
//                   }`}
//               >
//                 {repair.requestType?.toUpperCase()}
//               </span>
//             </div>
//           )}


//         </div>

//       </div>

//       {/* Company Details */}
//       <div className="bg-gray-100 text-start px-2 py-4 text-sm mt-4 rounded-lg">
//         <span className="font-mono font-semibold text-lg">Company Details</span>

//         <div className="flex justify-between flex-col lg:flex-row xl:flex-row overflow-x-auto">
//           <div className="flex flex-col text-start">
//             <span>
//               Company Name: <span className="font-semibold uppercase">{repair.companyName || "_"}</span>
//             </span>

//             <span>
//               received By: <span className="font-semibold">{repair.receivedBy || "_"}</span>
//             </span>

//             <span>
//               Handover Person: <span className="font-semibold">{repair.handoverPerson || "_"}</span>
//             </span>


//           </div>
//         </div>
//       </div>

//       {/* Instrument Details */}
//       <div className="bg-gray-100 text-start px-2 py-4 text-sm mt-4 rounded-lg">
//         <span className="font-mono font-semibold text-lg">Instrument Details</span>

//         <div className="hidden sm:block mt-4">
//           <table className="table-auto w-full text-left border-collapse text-sm">
//             <thead className="bg-gray-200">
//               <tr>
//                 <th className="px-4 py-2 border">Instrument Name</th>
//                 <th className="px-4 py-2 border">Qty</th>
//                 <th className="px-4 py-2 border">Server ID</th>
//                 <th className="px-4 py-2 border">Remark</th>
//               </tr>
//             </thead>

//             <tbody>
//               <tr className="hover:bg-gray-50">
//                 <td className="px-4 py-2 border w-fit">
//                   {repair.instrumentName || "N/A"}
//                 </td>

//                 <td className="px-4 py-2 border">
//                   {repair.quantity || 1}
//                 </td>

//                 <td className="px-4 py-2 border">
//                   {repair.serverId || "N/A"}
//                 </td>

//                 <td className="px-4 py-2 border">
//                   {repair.remark || "N/A"}
//                 </td>
//               </tr>
//             </tbody>

//           </table>
//         </div>
//       </div>

//       {/* Description / Status / Issue */}
//       {repair.description && (
//         <div className="bg-gray-100 text-start px-2 py-4 text-sm mt-4 rounded-lg">
//           <span className="font-mono font-semibold text-lg">Description / Remarks</span>
//           <p className="mt-2 whitespace-pre-line">{repair.description}</p>
//         </div>
//       )}

//       {repair.status && (
//         <div className="bg-gray-100 text-start px-2 py-4 text-sm mt-4 rounded-lg">
//           <span className="font-mono font-semibold text-lg">Current Status</span>
//           <p className="mt-2">
//             <span
//               className={`px-2 py-1 rounded-full font-bold ${repair.status === "completed"
//                 ? "bg-green-200 text-green-700"
//                 : repair.status === "in-progress"
//                   ? "bg-yellow-200 text-yellow-700"
//                   : repair.status === "pending"
//                     ? "bg-orange-200 text-orange-700"
//                     : "bg-gray-200 text-gray-700"
//                 }`}
//             >
//               {repair.status.toUpperCase()}
//             </span>
//           </p>
//         </div>
//       )}

//       {repair.issueDescription && (
//         <div className="bg-gray-100 text-start px-2 py-4 text-sm mt-4 rounded-lg">
//           <span className="font-mono font-semibold text-lg">Issue Description</span>
//           <p className="mt-2 whitespace-pre-line">{repair.issueDescription}</p>
//         </div>
//       )}

//       {/* Buttons */}
//       <div className="flex justify-between items-center mt-4">
//         <button
//           onClick={onClose}
//           className="px-3 py-2 bg-gray-300 rounded-lg text-black text-sm max-w-fit"
//         >
//           Close
//         </button>


//       </div>
//     </div>
//   );
// };

// export default RepairDetails;

import React, { useEffect, useState } from "react";

interface RepairDetailsProps {
  repair: any;
  onClose: () => void;
}

const RepairDetails: React.FC<RepairDetailsProps> = ({ repair, onClose }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.documentElement.style.colorScheme = "light";
  }, []);

  const formatDate = (date?: string) => {
    if (!date) return "N/A";
    try {
      return new Date(date).toLocaleDateString();
    } catch {
      return "Invalid Date";
    }
  };

  if (!repair) {
    return (
      <div className="bg-white p-5 rounded-lg shadow-lg text-center">
        <p>No repair data available.</p>
        <button
          onClick={onClose}
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md"
        >
          Close
        </button>
      </div>
    );
  }

  return (
    <div
      id="repair-details-section"
      className="relative w-full max-w-4xl max-h-[90vh] overflow-y-auto overflow-x-hidden no-scrollbar rounded-xl bg-white py-4 px-4 sm:px-6 lg:px-10 flex flex-col"
      style={{ color: "black" }}
    >
      {/* Logo */}
      <img
        src="/images/logo.png"
        className="w-24 sm:w-28 mb-4 self-center"
        alt="Logo"
      />

      {/* Top Layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6 mb-4">

        {/* LEFT */}
        <div className="flex flex-col items-center text-center text-sm">
          <img
            src="/images/user-pic.png"
            className="w-12 h-12 sm:w-16 sm:h-16 bg-gray-100 rounded-full my-2 object-cover"
            alt="user"
          />

          <span className="font-semibold text-base">Generated By</span>

          <span>
            Employee Name:{" "}
            <span className="font-semibold">
              {repair.createdBy?.username || "N/A"}
            </span>
          </span>

          <span>
            Employee Id:{" "}
            <span className="font-semibold text-blue-500 underline break-all">
              {repair.createdBy?.employeeId || "N/A"}
            </span>
          </span>
        </div>

        {/* CENTER (hidden on mobile) */}
        <div className="hidden lg:block"></div>

        {/* RIGHT */}
        <div className="flex flex-col text-sm lg:text-end">
          <span className="text-xs font-semibold">Order Number</span>

          <span className="text-blue-600 underline text-lg font-semibold font-mono">
            #{repair.orderNumber || "N/A"}
          </span>

          <span className="text-xs mt-2">
            Receiving Date:{" "}
            <span className="font-bold">
              {formatDate(repair.receivingDate)}
            </span>
          </span>

          <span className="text-xs">
            Expected Delivery Date:{" "}
            <span className="font-bold">
              {formatDate(repair.expectedDeliveryDate)}
            </span>
          </span>

          {repair.warrantyType && (
            <div className="mt-2 flex flex-wrap gap-2 lg:justify-end">
              <span className="px-3 py-1 rounded-full bg-gray-200 text-xs">
                {repair.warrantyType === "CUW"
                  ? "Complaint Under Warranty"
                  : "Complaint Out of Warranty"}
              </span>

              <span
                className={`px-3 py-1 rounded-full text-white text-xs ${repair.requestType === "repair"
                    ? "bg-blue-500"
                    : repair.requestType === "replacement"
                      ? "bg-green-500"
                      : "bg-gray-500"
                  }`}
              >
                {repair.requestType?.toUpperCase()}
              </span>
            </div>
          )}
        </div>
      </div>

      {/* Company Details */}
      <div className="bg-gray-100 px-4 py-4 text-sm mt-4 rounded-lg">
        <span className="font-semibold text-base">Company Details</span>

        <div className="flex flex-col justify-center lg:flex-row gap-2 lg:gap-8 mt-2">
          <span>
            Company Name:{" "}
            <span className="font-semibold uppercase">
              {repair.companyName || "_"}
            </span>
          </span>

          <span>
            Received By:{" "}
            <span className="font-semibold">
              {repair.receivedBy || "_"}
            </span>
          </span>

          <span>
            Handover Person:{" "}
            <span className="font-semibold">
              {repair.handoverPerson || "_"}
            </span>
          </span>
        </div>
      </div>

      {/* Instrument Details */}
      <div className="bg-gray-100 px-4 py-4 text-sm mt-4 rounded-lg">
        <span className="font-semibold text-base">
          Instrument Details
        </span>

        {/* Desktop Table */}
        <div className="hidden sm:block mt-4 overflow-x-auto">
          <table className="w-full text-left border-collapse text-sm">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-4 py-2 border">Instrument</th>
                <th className="px-4 py-2 border">Qty</th>
                <th className="px-4 py-2 border">Server ID</th>
                <th className="px-4 py-2 border">Remark</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-4 py-2 border">
                  {repair.instrumentName || "N/A"}
                </td>
                <td className="px-4 py-2 border">
                  {repair.quantity || 1}
                </td>
                <td className="px-4 py-2 border break-all">
                  {repair.serverId || "N/A"}
                </td>
                <td className="px-4 py-2 border">
                  {repair.remark || "N/A"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Mobile Card Layout */}
        <div className="sm:hidden mt-4 space-y-3">
          <div className="bg-white p-3 rounded-lg shadow-sm text-sm">
            <p><strong>Instrument:</strong> {repair.instrumentName || "N/A"}</p>
            <p><strong>Qty:</strong> {repair.quantity || 1}</p>
            <p className="break-all"><strong>Server ID:</strong> {repair.serverId || "N/A"}</p>
            <p><strong>Remark:</strong> {repair.remark || "N/A"}</p>
          </div>
        </div>
      </div>

      {/* Description */}
      {repair.description && (
        <div className="bg-gray-100 px-4 py-4 text-sm mt-4 rounded-lg">
          <span className="font-semibold text-base">
            Description / Remarks
          </span>
          <p className="mt-2 whitespace-pre-line">
            {repair.description}
          </p>
        </div>
      )}

      {/* Status */}
      {repair.status && (
        <div className="bg-gray-100 px-4 py-4 text-sm mt-4 rounded-lg">
          <span className="font-semibold text-base">
            Current Status
          </span>
          <p className="mt-2">
            <span
              className={`px-3 py-1 rounded-full font-bold text-sm ${repair.status === "completed"
                  ? "bg-green-200 text-green-700"
                  : repair.status === "in-progress"
                    ? "bg-yellow-200 text-yellow-700"
                    : repair.status === "pending"
                      ? "bg-orange-200 text-orange-700"
                      : "bg-gray-200 text-gray-700"
                }`}
            >
              {repair.status.toUpperCase()}
            </span>
          </p>
        </div>
      )}

      {/* Issue Description */}
      {repair.issueDescription && (
        <div className="bg-gray-100 px-4 py-4 text-sm mt-4 rounded-lg">
          <span className="font-semibold text-base">
            Issue Description
          </span>
          <p className="mt-2 whitespace-pre-line">
            {repair.issueDescription}
          </p>
        </div>
      )}

      {/* Buttons */}
      <div className="flex justify-end mt-6">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-300 rounded-lg text-sm"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default RepairDetails;